import React from "react";

import { CircuitStats as CircuitStatsComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface CircuitStatsProps {
    isInsideModal?: boolean;
    subDimensionsData?: any[];
    id?: string; //this prop allows ProgressScore component to scroll down to specific stat
}

const CircuitStats: React.FC<CircuitStatsProps> = ({
    isInsideModal = false,
    subDimensionsData,
    id,
}) => {
    const { circuitStatsData, isFetchingCircuitStats, isErrorCircuitStats } =
        useSessionDetailsContext();

    const isEmptyState = () => {
        if (isInsideModal) {
            return !subDimensionsData;
        } else if (
            !isErrorCircuitStats &&
            (!circuitStatsData ||
                circuitStatsData?.length === 0 ||
                (circuitStatsData || [])?.every((stat: any) => {
                    return stat?.dataset?.length === 0;
                }))
        ) {
            return true;
        }
    };

    if (isFetchingCircuitStats) {
        return <ContentLoader height="18rem" />;
    }

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-detail:circuit-stats:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="15rem"
                />
            </ComponentWrapper>
        );
    }

    if (!subDimensionsData && isErrorCircuitStats && !isFetchingCircuitStats) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="15rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <CircuitStatsComponent
            data={isInsideModal ? subDimensionsData : circuitStatsData}
            id={id}
        />
    );
};

export default CircuitStats;
